import React from "react";
import SignInContainer from "Containers/AuthContainer/SignInContainer/SignInContainer";

export const SignIn = () => {
  return <SignInContainer />;
};
